import React from 'react';
import { Navbar } from './components/ui/navbar/desktopNavbar/desktopNavbar.component';
import { Breadcrumbs } from './components/ui/breadcrumps/breadcrumps.component';
import { Box } from '@mui/material';
import { ToolbarContainer } from './components/ui/toolbar/container/toolbarContainer.component';
import { Workspace } from './components/ui/workspace/workspace.component';
import styles from './App.module.css';
// import { Footer } from './components/ui/footer/footer.component';
import { MobileNavbar } from './components/ui/navbar/mobileNavbar/mobileNavbar.component';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useAuthContext } from './contexts/auth';
import { LoginScreen } from './components/loginScreen/loginScreen.component';
import { LandingPage } from './components/landingPage/landingPage.component';
import { PortalAuthProvider } from './contexts/portalAuth';
import { PortalLayout } from './components/portal/portalLayout.component';
import { PortalJobs } from './components/portal/portalJobs.component';
import { PortalHome } from './components/portal/portalHome.component';
import { PortalCounters } from './components/portal/portalCounters.component';
import { PortalTicket } from './components/portal/portalTicket.component';
import { RegisterScreen } from './components/registerScreen/registerScreen.component';
import ClientList from './workspaces/clients/list';
import EquipmentList from './workspaces/equipments/equipmentsList/list';
import ContractsList from './workspaces/contracts/list';
import { Invoices } from './workspaces/invoices/invoices.component';
import InvoicesList from './workspaces/invoices/list';
import PurchaseInvoicesList from './workspaces/invoices/purchaseList';
import ViewInvoice from './workspaces/invoices/viewInvoice/viewInvoice.component';
import ViewPurchaseInvoice from './workspaces/invoices/viewPurchaseInvoice/viewPurchaseInvoice.component';
import { Profile } from './workspaces/profile/viewProfile/viewProfile.component';
import { TenantConfig } from './workspaces/tenantConfig/viewTenant/viewTenant.component';
import { TenantBasicInfo } from './workspaces/tenantConfig/viewTenant/tenantBasicInfo/tenantBasicInfo.component';
import { TenantSubscriptionInfo } from './workspaces/tenantConfig/viewTenant/tenantSubscriptionInfo/tenantSubscriptionInfo.component';
import { TenantUsersList } from './workspaces/tenantConfig/viewTenant/tenantUser/tenantUsersList.component';
import { TenantUserDetail } from './workspaces/tenantConfig/viewTenant/tenantUser/tenantUserDetail.component';
import { TenantPermissionGroups } from './workspaces/tenantConfig/viewTenant/tenantPermissions/tenantPermissionGroups.component';
import { TenantPermissionGroupDetail } from './workspaces/tenantConfig/viewTenant/tenantPermissions/tenantPermissionGroupDetail.component';
import { TenantSettingsSection } from './workspaces/tenantConfig/viewTenant/tenantSettings/tenantSettingsSection.component';
import { TenantWorkspaceSection } from './workspaces/tenantConfig/viewTenant/sections/tenantWorkspaceSection.component';
import { TenantAccessSection } from './workspaces/tenantConfig/viewTenant/sections/tenantAccessSection.component';
import { TenantSettingsSectionLayout } from './workspaces/tenantConfig/viewTenant/sections/tenantSettingsSection.component';
import { TenantAutomationSection } from './workspaces/tenantConfig/viewTenant/sections/tenantAutomationSection.component';
import { TenantNumberingSettings } from './workspaces/tenantConfig/viewTenant/tenantNumerationSchemas/tenantNumberingSettings.component';
import { LegacyTenantRedirect } from './workspaces/tenantConfig/legacyTenantRedirect.component';
import { TENANT_ROUTES } from './workspaces/tenantConfig/tenantConfig.routes';
import { TenantStatusTransitionActionsList } from './workspaces/tenantConfig/viewTenant/tenantStatusTransitionActions/tenantStatusTransitionActionsList.component';
import { TenantStatusTransitionActionDetail } from './workspaces/tenantConfig/viewTenant/tenantStatusTransitionActions/tenantStatusTransitionActionDetail.component';
import { TenantNumerationSchemaDetail } from './workspaces/tenantConfig/viewTenant/tenantNumerationSchemas/tenantNumerationSchemaDetail.component';
import { TenantSettlementAutomation } from './workspaces/tenantConfig/viewTenant/tenantSettlementAutomation/tenantSettlementAutomation.component';
import { TenantClientPortal } from './workspaces/tenantConfig/viewTenant/tenantClientPortal/tenantClientPortal.component';
import { ClientPortalAccess } from './workspaces/clients/viewClient/clientPortalAccess/clientPortalAccess.component';
import { ClientInvoiceSettings } from './workspaces/clients/viewClient/clientInvoiceSettings/clientInvoiceSettings.component';
import { ProfileActions } from './toolbars/profileActions/profileActions.component';
import { ClientsActions } from './toolbars/clientsActions/clientsListActions.component';
import { TenantActions } from './toolbars/tenantActions/tenantActions.component';
import { TenantUserActions } from './toolbars/tenantUserActions/tenantUserActions.component';
import { ClientsDetailsActions } from './toolbars/clientsActions/clientsDetailsActions.component';
import { ClientPortalAccessActions } from './toolbars/clientsActions/clientPortalAccessActions.component';
import { ClientInvoiceSettingsActions } from './toolbars/clientsActions/clientInvoiceSettingsActions.component';
import { ViewClient } from './workspaces/clients/viewClient/viewClient.component';
import { ClientBasicInfo } from './workspaces/clients/viewClient/clientBasicInfo/clientBasicInfo.component';
import { ClientContracts } from './workspaces/clients/viewClient/clientContracts/clientContracts.component';
import { ClientSettlements } from './workspaces/clients/viewClient/clientSettlements/clientSettlements.component';
import { ClientSettlementsDetail } from './workspaces/clients/viewClient/clientSettlementsDetail/clientSettlementsDetail.component';
import { ClientEquipmentsActive } from './workspaces/clients/viewClient/clientEquipments/clientEquipmentsActive.component';
import { ClientEquipmentsExpired } from './workspaces/clients/viewClient/clientEquipments/clientEquipmentsExpired.component';
import { ViewEquipment } from './workspaces/equipments/equipmentsList/viewEquipment/viewEquipment.component';
import { EquipmentBasicInfo } from './workspaces/equipments/equipmentsList/viewEquipment/equipmentBasicInfo/equipmentBasicInfo.component';
import { EquipmentCounters } from './workspaces/equipments/equipmentsList/viewEquipment/equipmentCounters/equipmentCounters.component';
import { EquipmentCounterDetail } from './workspaces/equipments/equipmentsList/viewEquipment/equipmentCounters/equipmentCounterDetail/equipmentCounterDetail.component';
import { EquipmentContracts } from './workspaces/equipments/equipmentsList/viewEquipment/equipmentContracts/equipmentContracts.component';
import { EquipmentServiceHistory } from './workspaces/equipments/equipmentsList/viewEquipment/equipmentServiceHistory/equipmentServiceHistory.component';
import { EquipmentServiceStats } from './workspaces/equipments/equipmentsList/viewEquipment/equipmentServiceStats/equipmentServiceStats.component';
import { Equipments } from './workspaces/equipments/equipments.component';
import ProducersList from './workspaces/equipments/producersList/list';
import { ProducerBasicInfo } from './workspaces/equipments/producersList/viewProducer/producerBasicInfo.component';
import ConfigurationsList from './workspaces/equipments/configurationsList/list';
import { ConfigurationBasicInfo } from './workspaces/equipments/configurationsList/viewConfiguration/configurationBasicInfo.component';
import { ViewContract } from './workspaces/contracts/viewContract/viewContract.component';
import { ContractBasicInfo } from './workspaces/contracts/viewContract/contractBasicInfo/contractBasicInfo.component';
import { ContractTerms } from './workspaces/contracts/viewContract/contractTerms/contractTerms.component';
import { ContractSettlements } from './workspaces/contracts/viewContract/contractSettlements/contractSettlements.component';
import { ContractHistory } from './workspaces/contracts/viewContract/contractHistory.component';
import { SaleSummary } from './workspaces/contracts/viewContract/saleSummary/saleSummary.component';
import { SaleSummaryDetail } from './workspaces/contracts/viewContract/saleSummary/saleSummaryDetail.component';
import { ContractTermDetail } from './workspaces/contracts/viewContract/contractTerms/contractTermDetail/contractTermDetail.component';
import { SettlementsList } from './workspaces/settlements/list';
import { Settlements } from './workspaces/settlements/settlements.component';
import { SettlementsStatistics } from './workspaces/settlements/statistics/statistics.component';
import { SettlementsProfitability } from './workspaces/settlements/profitability/profitability.component';
import { ViewSettlement } from './workspaces/settlements/viewSettlement/viewSettlement.component';
import { SettlementBasicInfo } from './workspaces/settlements/viewSettlement/settlementBasicInfo/settlementBasicInfo.component';
import { SettlementPositions } from './workspaces/settlements/viewSettlement/settlementPositions/settlementPositions.component';
import { SettlementExtraPositions } from './workspaces/settlements/viewSettlement/settlementExtraPositions/settlementExtraPositions.component';
import { TenantPermissionGroupActions } from './toolbars/tenantPermissionGroupActions/tenantPermissionGroupActions.component';
import { TenantNumerationSchemaActions } from './toolbars/tenantNumerationSchemaActions/tenantNumerationSchemaActions.component';
import { TenantStatusTransitionActionActions } from './toolbars/tenantStatusTransitionActionActions/tenantStatusTransitionActionActions.component';
import { EquipmentsActions } from './toolbars/equipmentsActions/equipmentsListActions.component';
import { ProducersListActions } from './toolbars/equipmentsActions/producersListActions.component';
import { ConfigurationsListActions } from './toolbars/equipmentsActions/configurationsListActions.component';
import { EquipmentsDetailsActions } from './toolbars/equipmentsActions/equipmentsDetailsActions.component';
import { EquipmentCounterDetailActions } from './toolbars/equipmentCountersActions/equipmentCounterDetailActions.component';
import { ProducerDetailsActions } from './toolbars/equipmentsActions/producerDetailsActions.component';
import { ConfigurationDetailsActions } from './toolbars/equipmentsActions/configurationDetailsActions.component';
import { ContractsActions } from './toolbars/contractsActions/contractsListActions.component';
import { ContractsDetailsActions } from './toolbars/contractsActions/contractsDetailsActions.component';
import { InvoicesListActions } from './toolbars/invoicesActions/invoicesListActions.component';
import { InvoiceDetailsActions } from './toolbars/invoicesActions/invoiceDetailsActions.component';
import { PurchaseInvoicesListActions } from './toolbars/invoicesActions/purchaseInvoicesListActions.component';
import { PurchaseInvoiceDetailsActions } from './toolbars/invoicesActions/purchaseInvoiceDetailsActions.component';
import { SettlementsActions } from './toolbars/settlementsActions/settlementsListActions.component';
import { SettlementsDetailsActions } from './toolbars/settlementsActions/settlementsDetailsActions.component';
import { SettlementsStatisticsActions } from './toolbars/settlementsActions/settlementsStatisticsActions.component';
import { SettlementsProfitabilityActions } from './toolbars/settlementsActions/settlementsProfitabilityActions.component';
import CustomCircularProgress from './components/ui/customCircularProgress/customCircularProgress.component';
import { ServiceUnavailable } from './components/ui/serviceUnavailable/serviceUnavailable.component';
import { Service } from './workspaces/service/service.component';
import JobIssuesList from './workspaces/service/jobIssues/list';
import { JobIssueBasicInfo } from './workspaces/service/jobIssues/viewJobIssue/jobIssueBasicInfo.component';
import JobServicesCatalogList from './workspaces/service/jobServices/list';
import { JobServiceCatalogBasicInfo } from './workspaces/service/jobServices/viewJobService/jobServiceCatalogBasicInfo.component';
import JobsList from './workspaces/service/jobs/list';
import { JobBasicInfo } from './workspaces/service/jobs/viewJob/jobBasicInfo.component';
import { JobEquipmentsServiceHistory } from './workspaces/service/jobs/viewJob/jobEquipmentsServiceHistory.component';
import { JobHistory } from './workspaces/service/jobs/viewJob/jobHistory.component';
import { JobMessages } from './workspaces/service/jobs/viewJob/jobMessages.component';
import { ViewJob } from './workspaces/service/jobs/viewJob/viewJob.component';
import StockStatusList from './workspaces/service/stockStatus/list';
import { ViewPart } from './workspaces/service/stockStatus/viewPart/viewPart.component';
import { PartBasicInfo } from './workspaces/service/stockStatus/viewPart/partBasicInfo.component';
import { OrderedParts } from './workspaces/service/stockStatus/viewPart/orderedParts.component';
import { UsedParts } from './workspaces/service/stockStatus/viewPart/usedParts.component';
import { OrderedPartBasicInfo } from './workspaces/service/stockStatus/viewPart/orderedPartBasicInfo.component';
import { UsedPartBasicInfo } from './workspaces/service/stockStatus/viewPart/usedPartBasicInfo.component';
import { Statistics } from './workspaces/service/statistics/statistics.component';
import EquipmentGroupsList from './workspaces/service/statistics/equipmentGroups/list';
import { EquipmentGroupBasicInfo } from './workspaces/service/statistics/equipmentGroups/viewEquipmentGroup/equipmentGroupBasicInfo.component';
import TechniciansList from './workspaces/service/statistics/technicians/list';
import { TechnicianStats } from './workspaces/service/statistics/technicians/viewTechnician/technicianStats.component';
import { EquipmentStats } from './workspaces/service/statistics/equipmentStats/equipmentStats.component';
import { GroupStats } from './workspaces/service/statistics/groupStats/groupStats.component';
import { GeneralStats } from './workspaces/service/statistics/generalStats/generalStats.component';
import { JobServiceListActions } from './toolbars/serviceActions/jobServiceListActions.component';
import { JobIssuesListActions } from './toolbars/serviceActions/jobIssuesListActions.component';
import { JobIssueDetailsActions } from './toolbars/serviceActions/jobIssueDetailsActions.component';
import { JobServicesCatalogListActions } from './toolbars/serviceActions/jobServicesCatalogListActions.component';
import { JobServiceCatalogDetailsActions } from './toolbars/serviceActions/jobServiceCatalogDetailsActions.component';
import { JobsListActions } from './toolbars/serviceActions/jobsListActions.component';
import { JobDetailsActions } from './toolbars/serviceActions/jobDetailsActions.component';
import { StockStatusListActions } from './toolbars/serviceActions/stockStatusListActions.component';
import { PartDetailsActions } from './toolbars/serviceActions/partDetailsActions.component';
import { OrderedPartDetailsActions } from './toolbars/serviceActions/orderedPartDetailsActions.component';
import { UsedPartDetailsActions } from './toolbars/serviceActions/usedPartDetailsActions.component';
import { EquipmentGroupsListActions } from './toolbars/serviceActions/equipmentGroupsListActions.component';
import { EquipmentGroupDetailsActions } from './toolbars/serviceActions/equipmentGroupDetailsActions.component';
import { StatisticsReadOnlyActions } from './toolbars/serviceActions/statisticsReadOnlyActions.component';
import { EquipmentStatsActions } from './toolbars/serviceActions/equipmentStatsActions.component';
import { GroupStatsActions } from './toolbars/serviceActions/groupStatsActions.component';
import { GeneralStatsActions } from './toolbars/serviceActions/generalStatsActions.component';
import { TechnicianStatsActions } from './toolbars/serviceActions/technicianStatsActions.component';
import { EquipmentServiceStatsActions } from './toolbars/equipmentsActions/equipmentServiceStatsActions.component';
import { DashboardComponent } from './workspaces/dashboard/dashboard.component';
import { DashboardActions } from './toolbars/dashboardActions/dashboardActions.component';
import { CompleteProfileModal } from './components/completeProfileModal/completeProfileModal.component';
import { SetupBiometricLoginModal } from './components/setupBiometricLoginModal/setupBiometricLoginModal.component';
import { SubscriptionGate } from './components/subscriptionGate/subscriptionGate.component';
import { SubscriptionBanner } from './components/subscriptionBanner/subscriptionBanner.component';
import { LegalAcceptanceModal } from './components/legalAcceptanceModal/legalAcceptanceModal.component';

const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const { isSecure, currentUser, currentUserLoading } = useAuthContext();

  if (!isSecure) {
    return <Navigate to="/" replace />;
  }

  if (currentUser === null && !currentUserLoading) {
    return <ServiceUnavailable />;
  }

  if (!currentUser) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <CustomCircularProgress />
      </Box>
    );
  }

  const subscription = currentUser.tenant?.subscription;
  if (subscription?.is_blocked) {
    return (
      <SubscriptionGate
        reason={subscription.block_reason ?? 'DUNNING'}
        subscription={subscription}
      />
    );
  }

  return children;
};

// Public Route wrapper - redirects authenticated users to main app
const PublicRoute = ({ children }: { children: React.ReactElement }) => {
  const { isSecure } = useAuthContext();

  if (isSecure) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

// Main app layout for authenticated users
const AppLayout = () => {
  return (
    <Box className={styles.mainBox}>
      <LegalAcceptanceModal />
      <CompleteProfileModal />
      <SetupBiometricLoginModal />
      <Navbar />
      <Box className={styles.rightBox}>
        <Breadcrumbs />
        <SubscriptionBanner />
        <Box className={styles.contentBox}>
          {/* Workspace routes */}
          <Routes>
            <Route element={<Workspace />}>
              <Route
                path="/home"
                element={<DashboardComponent />}
              />
              <Route path="/clients" element={<ClientList />} />
              <Route path="/clients/:id" element={<ViewClient />}>
                <Route index element={<ClientBasicInfo />} />
                <Route path="contracts" element={<ClientContracts />} />
                <Route path="settlements" element={<ClientSettlements />} />
                <Route path="settlements/:period" element={<ClientSettlementsDetail />} />
                <Route path="active-equipment" element={<ClientEquipmentsActive />} />
                <Route path="expired-equipment" element={<ClientEquipmentsExpired />} />
                <Route path="portal-access" element={<ClientPortalAccess />} />
                <Route path="invoice-settings" element={<ClientInvoiceSettings />} />
              </Route>
              <Route path="/equipment-section" element={<Equipments />}>
                <Route index element={<Navigate to="/equipment-section/equipments" replace />} />
                <Route path="equipments" element={<EquipmentList />} />
                <Route path="equipments/:id" element={<ViewEquipment />}>
                  <Route index element={<EquipmentBasicInfo />} />
                  <Route path="counters" element={<EquipmentCounters />} />
                  <Route path="counters/:counterId" element={<EquipmentCounterDetail />} />
                  <Route path="assigned-contracts" element={<EquipmentContracts />} />
                  <Route path="history" element={<EquipmentServiceHistory />} />
                  <Route path="service-stats" element={<EquipmentServiceStats />} />
                </Route>
                <Route path="producers" element={<ProducersList />} />
                <Route path="producers/:id" element={<ProducerBasicInfo />} />
                <Route path="configurations" element={<ConfigurationsList />} />
                <Route path="configurations/:id" element={<ConfigurationBasicInfo />} />
              </Route>
              <Route path="/contracts" element={<ContractsList />} />
              <Route path="/contracts/:id" element={<ViewContract />}>
                <Route index element={<ContractBasicInfo />} />
                <Route path="equipment" element={<ContractTerms />} />
                <Route path="equipment/:termId" element={<ContractTermDetail />} />
                <Route path="settlements" element={<ContractSettlements />} />
                <Route path="history" element={<ContractHistory />} />
                <Route path="sale-summary" element={<SaleSummary />} />
                <Route path="sale-summary/:saleDate" element={<SaleSummaryDetail />} />
              </Route>
              <Route path="/invoices" element={<Invoices />}>
                <Route index element={<InvoicesList />} />
                <Route path="purchase" element={<PurchaseInvoicesList />} />
              </Route>
              <Route path="/invoices/purchase/:id" element={<ViewPurchaseInvoice />} />
              <Route path="/invoices/:id" element={<ViewInvoice />} />
              <Route path="/settlements" element={<Settlements />}>
                <Route index element={<SettlementsList />} />
                <Route path="statistics" element={<SettlementsStatistics />} />
                <Route path="profitability" element={<SettlementsProfitability />} />
              </Route>
              <Route path="/settlements/:id" element={<ViewSettlement />}>
                <Route index element={<SettlementBasicInfo />} />
                <Route path="positions" element={<SettlementPositions />} />
                <Route path="extra-positions" element={<SettlementExtraPositions />} />
              </Route>
              <Route path="/service" element={<Service />}>
                <Route index element={<Navigate to="/service/jobs" replace />} />
                <Route path="jobs" element={<JobsList />} />
                <Route path="jobs/:id" element={<ViewJob />}>
                  <Route index element={<JobBasicInfo />} />
                  <Route path="service-history" element={<JobEquipmentsServiceHistory />} />
                  <Route path="history" element={<JobHistory />} />
                  <Route path="messages" element={<JobMessages />} />
                </Route>
                <Route path="issues-catalog" element={<JobIssuesList />} />
                <Route path="issues-catalog/:id" element={<JobIssueBasicInfo />} />
                <Route path="services-catalog" element={<JobServicesCatalogList />} />
                <Route path="services-catalog/:id" element={<JobServiceCatalogBasicInfo />} />
                <Route path="stock-status" element={<StockStatusList />} />
                <Route path="stock-status/:id" element={<ViewPart />}>
                  <Route index element={<PartBasicInfo />} />
                  <Route path="ordered-parts" element={<OrderedParts />} />
                  <Route path="ordered-parts/:orderedPartId" element={<OrderedPartBasicInfo />} />
                  <Route path="used-parts" element={<UsedParts />} />
                  <Route path="used-parts/:usedPartId" element={<UsedPartBasicInfo />} />
                </Route>
                <Route path="statistics" element={<Statistics />}>
                  <Route index element={<Navigate to="/service/statistics/general-stats" replace />} />
                  <Route path="general-stats" element={<GeneralStats />} />
                  <Route path="technicians" element={<TechniciansList />} />
                  <Route path="technicians/:id" element={<TechnicianStats />} />
                  <Route path="equipment-stats" element={<EquipmentStats />} />
                  <Route path="group-stats" element={<GroupStats />} />
                  <Route path="equipment-groups" element={<EquipmentGroupsList />} />
                  <Route path="equipment-groups/:id" element={<EquipmentGroupBasicInfo />} />
                </Route>
              </Route>
              <Route path="/profile" element={<Profile />} />
              <Route path="/tenant" element={<TenantConfig />}>
                <Route element={<TenantWorkspaceSection />}>
                  <Route index element={<TenantBasicInfo />} />
                  <Route path="subscription" element={<TenantSubscriptionInfo />} />
                </Route>
                <Route element={<TenantAccessSection />}>
                  <Route path="users" element={<TenantUsersList />} />
                  <Route path="users/:id" element={<TenantUserDetail />} />
                  <Route path="permission-groups" element={<TenantPermissionGroups />} />
                  <Route path="permission-groups/:id" element={<TenantPermissionGroupDetail />} />
                </Route>
                <Route path="settings" element={<TenantSettingsSectionLayout />}>
                  <Route index element={<TenantSettingsSection section="general" />} />
                  <Route path="numbering" element={<TenantNumberingSettings />} />
                  <Route path="numbering/:id" element={<TenantNumerationSchemaDetail />} />
                  <Route path="invoicing" element={<TenantSettingsSection section="invoicing" />} />
                  <Route path="reminders" element={<TenantSettingsSection section="reminders" />} />
                  <Route path="client-portal" element={<TenantClientPortal />} />
                </Route>
                <Route path="automation" element={<TenantAutomationSection />}>
                  <Route index element={<TenantSettlementAutomation />} />
                  <Route path="job-status-actions" element={<TenantStatusTransitionActionsList />} />
                  <Route path="job-status-actions/:id" element={<TenantStatusTransitionActionDetail />} />
                </Route>
                {/* Addresses these pages used before the workspace was regrouped. */}
                <Route path="numeration-schemas" element={<LegacyTenantRedirect to={TENANT_ROUTES.numbering} />} />
                <Route path="numeration-schemas/:id" element={<LegacyTenantRedirect to={TENANT_ROUTES.numbering} />} />
                <Route path="status-transition-actions" element={<LegacyTenantRedirect to={TENANT_ROUTES.jobStatusActions} />} />
                <Route path="status-transition-actions/:id" element={<LegacyTenantRedirect to={TENANT_ROUTES.jobStatusActions} />} />
                <Route path="client-portal" element={<LegacyTenantRedirect to={TENANT_ROUTES.clientPortal} />} />
              </Route>
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Route>
          </Routes>
          {/* Toolbar routes */}
          <Routes>
            <Route element={<ToolbarContainer />}>
              <Route
                path="/home"
                element={<DashboardActions />}
              />
              <Route path="/clients" element={<ClientsActions />} />
              <Route path="/clients/:id" element={<ClientsDetailsActions />} />
              <Route path="/clients/:id/contracts" element={<ClientsDetailsActions />} />
              <Route path="/clients/:id/settlements" element={<ClientsDetailsActions />} />
              <Route path="/clients/:id/settlements/:period" element={<ClientsDetailsActions />} />
              <Route path="/clients/:id/active-equipment" element={<ClientsDetailsActions />} />
              <Route path="/clients/:id/expired-equipment" element={<ClientsDetailsActions />} />
              <Route path="/clients/:id/portal-access" element={<ClientPortalAccessActions />} />
              <Route path="/clients/:id/invoice-settings" element={<ClientInvoiceSettingsActions />} />
              <Route path="/equipment-section" element={<EquipmentsActions />} />
              <Route path="/equipment-section/equipments" element={<EquipmentsActions />} />
              <Route path="/equipment-section/producers" element={<ProducersListActions />} />
              <Route path="/equipment-section/producers/:id" element={<ProducerDetailsActions />} />
              <Route path="/equipment-section/configurations" element={<ConfigurationsListActions />} />
              <Route path="/equipment-section/configurations/:id" element={<ConfigurationDetailsActions />} />
              <Route path="/equipment-section/equipments/:id" element={<EquipmentsDetailsActions />} />
              <Route path="/equipment-section/equipments/:id/counters" element={<EquipmentsDetailsActions />} />
              <Route path="/equipment-section/equipments/:id/counters/:counterId" element={<EquipmentCounterDetailActions />} />
              <Route path="/equipment-section/equipments/:id/assigned-contracts" element={<EquipmentsDetailsActions />} />
              <Route path="/equipment-section/equipments/:id/history" element={<EquipmentsDetailsActions />} />
              <Route path="/equipment-section/equipments/:id/service-stats" element={<EquipmentServiceStatsActions />} />
              <Route path="/contracts" element={<ContractsActions />} />
              <Route path="/contracts/:id" element={<ContractsDetailsActions />} />
              <Route path="/contracts/:id/equipment" element={<ContractsDetailsActions />} />
              <Route path="/contracts/:id/equipment/:termId" element={<ContractsDetailsActions />} />
              <Route path="/contracts/:id/settlements" element={<ContractsDetailsActions />} />
              <Route path="/contracts/:id/history" element={<ContractsDetailsActions />} />
              <Route path="/contracts/:id/sale-summary" element={<ContractsDetailsActions />} />
              <Route path="/contracts/:id/sale-summary/:saleDate" element={<ContractsDetailsActions />} />
              <Route path="/invoices" element={<InvoicesListActions />} />
              <Route path="/invoices/purchase" element={<PurchaseInvoicesListActions />} />
              <Route path="/invoices/purchase/:id" element={<PurchaseInvoiceDetailsActions />} />
              <Route path="/invoices/:id" element={<InvoiceDetailsActions />} />
              <Route path="/settlements" element={<SettlementsActions />} />
              <Route path="/settlements/statistics" element={<SettlementsStatisticsActions />} />
              <Route path="/settlements/profitability" element={<SettlementsProfitabilityActions />} />
              <Route path="/settlements/:id" element={<SettlementsDetailsActions />}>
                <Route index element={<SettlementBasicInfo />} />
                <Route path="positions" element={<SettlementPositions />} />
                <Route path="extra-positions" element={<SettlementExtraPositions />} />
              </Route>
              <Route path="/service" element={<JobServiceListActions />} />
              <Route path="/service/jobs" element={<JobsListActions />} />
              <Route path="/service/jobs/:id" element={<JobDetailsActions />} />
              <Route path="/service/jobs/:id/service-history" element={<JobDetailsActions />} />
              <Route path="/service/jobs/:id/history" element={<JobDetailsActions />} />
              <Route path="/service/jobs/:id/messages" element={<JobDetailsActions />} />
              <Route path="/service/issues-catalog" element={<JobIssuesListActions />} />
              <Route path="/service/issues-catalog/:id" element={<JobIssueDetailsActions />} />
              <Route path="/service/services-catalog" element={<JobServicesCatalogListActions />} />
              <Route path="/service/services-catalog/:id" element={<JobServiceCatalogDetailsActions />} />
              <Route path="/service/stock-status" element={<StockStatusListActions />} />
              <Route path="/service/stock-status/:id" element={<PartDetailsActions />} />
              <Route path="/service/stock-status/:id/ordered-parts" element={<PartDetailsActions />} />
              <Route path="/service/stock-status/:id/ordered-parts/:orderedPartId" element={<OrderedPartDetailsActions />} />
              <Route path="/service/stock-status/:id/used-parts" element={<PartDetailsActions />} />
              <Route path="/service/stock-status/:id/used-parts/:usedPartId" element={<UsedPartDetailsActions />} />
              <Route path="/service/statistics" element={<StatisticsReadOnlyActions />} />
              <Route path="/service/statistics/general-stats" element={<GeneralStatsActions />} />
              <Route path="/service/statistics/equipment-groups" element={<EquipmentGroupsListActions />} />
              <Route path="/service/statistics/equipment-groups/:id" element={<EquipmentGroupDetailsActions />} />
              <Route path="/service/statistics/technicians" element={<StatisticsReadOnlyActions />} />
              <Route path="/service/statistics/technicians/:id" element={<TechnicianStatsActions />} />
              <Route path="/service/statistics/equipment-stats" element={<EquipmentStatsActions />} />
              <Route path="/service/statistics/group-stats" element={<GroupStatsActions />} />
              <Route path="/profile" element={<ProfileActions />} />
              <Route path="/tenant" element={<TenantActions />} />
              <Route path="/tenant/subscription" element={<TenantActions />} />
              <Route path="/tenant/users" element={<TenantActions />} />
              <Route path="/tenant/users/:id" element={<TenantUserActions />} />
              <Route path="/tenant/permission-groups" element={<TenantActions />} />
              <Route path="/tenant/permission-groups/:id" element={<TenantPermissionGroupActions />} />
              <Route path="/tenant/settings" element={<TenantActions />} />
              <Route path="/tenant/settings/numbering" element={<TenantActions />} />
              <Route path="/tenant/settings/numbering/:id" element={<TenantNumerationSchemaActions />} />
              <Route path="/tenant/settings/invoicing" element={<TenantActions />} />
              <Route path="/tenant/settings/reminders" element={<TenantActions />} />
              <Route path="/tenant/settings/client-portal" element={<TenantActions />} />
              <Route path="/tenant/automation" element={<TenantActions />} />
              <Route path="/tenant/automation/job-status-actions" element={<TenantActions />} />
              <Route path="/tenant/automation/job-status-actions/:id" element={<TenantStatusTransitionActionActions />} />
              <Route
                path="*"
                element={<p>Toolbar content component goes here.</p>}
              />
            </Route>
          </Routes>
        </Box>
        {/* <Footer /> */}
        <MobileNavbar />
      </Box>
    </Box>
  );
};

export default function App() {
  return (
    <Routes>
      {/* Client portal - a separate, public-facing tree with its own auth,
          its own tokens and no staff chrome. Declared before the catch-all
          so a signed-in staff session never swallows a client's link. */}
      <Route
        path="/portal/:slug"
        element={
          <PortalAuthProvider>
            <PortalLayout />
          </PortalAuthProvider>
        }
      >
        <Route index element={<PortalHome />} />
        <Route path="jobs" element={<PortalJobs />} />
        <Route path="counters" element={<PortalCounters />} />
        <Route path="report" element={<PortalTicket />} />
      </Route>

      {/* Public routes */}
      <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><LoginScreen /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterScreen /></PublicRoute>} />

      {/* Protected routes - catch all */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
